import axios from "axios";

/** Live backend used when REACT_APP_BACKEND_API_URL is unset. Set that env to `mock` to use local mocks. */
const TESTING_BACKEND_URL = "https://testing1.lite.tradelyft.in";
const STALE_TESTING_BACKEND_URL = "https://testing.lite.tradelyft.in";

// If using mocks, baseURL should be empty so setupProxy can intercept.
// If using real API, use the full backend origin (no trailing slash).
const getBaseURL = () => {
  let raw = String(process.env.REACT_APP_BACKEND_API_URL ?? "").trim().replace(/\/+$/, "");

  // CRA bakes REACT_APP_* at `npm start`. A leftover testing.lite value would
  // keep calling the old host until the dev server is restarted.
  if (!raw || raw === STALE_TESTING_BACKEND_URL) {
    return TESTING_BACKEND_URL;
  }

  if (raw.toLowerCase() === "mock" || raw === "/api" || raw.startsWith("/api/") || raw.startsWith("/")) {
    return "";
  }

  return raw;
};

const axiosInstance = axios.create({
    baseURL: getBaseURL()
});

function isPublicAuthRequest(url = "") {
    const path = String(url);
    return (
        path.includes("/users/login") ||
        path.includes("token/refresh") ||
        path.includes("forgot-password")
    );
}

let requestInterceptorId = null;
let responseInterceptorId = null;

export function setUpInterceptors(auth, logout, tryTokenRefresh) {
    if (requestInterceptorId != null) {
        axiosInstance.interceptors.request.eject(requestInterceptorId);
    }
    if (responseInterceptorId != null) {
        axiosInstance.interceptors.response.eject(responseInterceptorId);
    }

    requestInterceptorId = axiosInstance.interceptors.request.use(
        (config) => {
            if (isPublicAuthRequest(config.url)) {
                return config;
            }

            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers.Authorization = `Bearer ${access_token}`;
            }
    
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    responseInterceptorId = axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config || {};

            if (
                error.response?.status === 401 &&
                !originalRequest._retry &&
                !isPublicAuthRequest(originalRequest.url)
            ) {
                originalRequest._retry = true;

                try {
                    await tryTokenRefresh();

                    const access_token = localStorage.getItem("access_token");
                    originalRequest.headers.Authorization = `Bearer ${access_token}`;

                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    logout();
                    return Promise.reject(refreshError);
                }
                
            }
    
            return Promise.reject(error);
        }
    );
    
}

export default axiosInstance;
